var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useLocation } from "react-router";
var banner = function () {
    var item = useSelector(function (state) { return state.product.item; });
    var itemLoadState = useSelector(function (state) { return state.product.item; });
    var search = useLocation().search;
    var attachQueryString = function () {
        if (search.includes('ad_code')) {
            var queryStringAdCode = new URLSearchParams(search).get('ad_code');
            if (queryStringAdCode === 'dap008') {
                return search;
            }
        }
        return '';
    };
    return (React.createElement(React.Fragment, null, item &&
        React.createElement(Iframe, { title: "\uD589\uBCF5\uC1FC\uD551", src: "".concat(process.env.REACT_APP_AD_URL, "/dap008/").concat(item.cate_id) + attachQueryString(), scrolling: "no", id: 'dap008_ad' })));
};
var Iframe = styled.iframe(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: 0;\n    margin: 0 0 40px;\n    width: 100%;\n    height: 165px;\n"], ["\n    border: 0;\n    margin: 0 0 40px;\n    width: 100%;\n    height: 165px;\n"])));
export default banner;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/adv/banner.tsx
// module id = 217
// module chunks = 0